var map = {
	"./augusta-national-10.jpg": 3873,
	"./augusta-national-16.jpg": 5860,
	"./fall-greenside.jpg": 8424,
	"./full-swing-fitzpatrick.jpg": 6213,
	"./full-swing-greg.jpg": 2913,
	"./full-swing-poulter.jpg": 7669,
	"./full-swing-rory.jpg": 8692,
	"./full-swing-thomas-spieth.jpg": 3697,
	"./hero/2k23-tpc-sawgrass-17.jpg": 4459,
	"./hero/augusta-national-hero.jpg": 3209,
	"./hero/awards-hero.jpg": 2820,
	"./hero/birdie-challenge-hero.jpg": 4242,
	"./hero/cold-weather-hero.jpg": 4878,
	"./hero/dove-valley-ranch-hero.jpg": 7502,
	"./hero/fall-golf-hero.jpg": 8018,
	"./hero/full-swing-hero.jpg": 4294,
	"./hero/og/2k23-tpc-sawgrass-17.jpg": 6201,
	"./hero/og/augusta-national-hero.jpg": 9985,
	"./hero/og/awards-hero.jpg": 1762,
	"./hero/og/birdie-challenge-hero.jpg": 6867,
	"./hero/og/cold-weather-hero.jpg": 5942,
	"./hero/og/dove-valley-ranch-hero.jpg": 801,
	"./hero/og/fall-golf-hero.jpg": 4793,
	"./hero/og/full-swing-hero.jpg": 2181,
	"./hero/og/reboot-hero.jpg": 529,
	"./hero/og/rory-vs-greg-hero.jpg": 9290,
	"./hero/reboot-hero.jpg": 2740,
	"./hero/rory-vs-greg-hero.jpg": 6592,
	"./stories/20210427-reboot-game.md": 3989,
	"./stories/20210430-birdie-challenge-update.md": 8960,
	"./stories/20210730-birdie-challenge-update.md": 4765,
	"./stories/20211111-first-eagle.md": 9521,
	"./stories/20220930-fall-golf.md": 3029,
	"./stories/20221010-top-5-alister-mackenzie.md": 2433,
	"./stories/20221101-cold-weather-tips.md": 5648,
	"./stories/20230201-january-players-of-the-month.md": 8610,
	"./stories/20230227-netflix-full-swing-season-1-review.md": 1405,
	"./stories/20230301-february-players-of-the-month.md": 3359,
	"./stories/20230306-can-pga-tour-and-liv-golf-coexist.md": 8136,
	"./stories/20230313-is-the-players-still-the-fifth-major.md": 5931,
	"./stories/20230320-bittersweet-spring.md": 8086,
	"./stories/20230401-augusta-national-to-open-for-public-tee-times.md": 7032,
	"./stories/20230403-march-players-of-the-month.md": 8151,
	"./stories/20230501-april-players-of-the-month.md": 2387
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2005;